module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cNKco"))).then(() => parcelRequire('d0iPb'));